import { render, staticRenderFns } from "./QuestionValue.vue?vue&type=template&id=72fb79ee"
import script from "./QuestionValue.vue?vue&type=script&lang=js"
export * from "./QuestionValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports